/* MIST blog row (2026-10-13). Reads the public WordPress RSS feed and post sitemap from the same origin (/blog/…)
   and fills [data-mv2-blog] .mv2-blog__list with the latest posts. The WP REST API needs a login, so it isn't used.
   Collection guide images are set in Liquid (mist-collection-guides), so collection pages fetch nothing. */
(function () {
  if (window.__mistBlog) return;
  window.__mistBlog = true;
  var wpHost = /^https?:\/\/(www\.)?misteliquidblog\.co\.uk\//i;
  var toBlog = function (u) { return (u || '').trim().replace(wpHost, '/blog/'); };
  var slugOf = function (u) { return toBlog(u).replace(/^https?:\/\/[^/]+/, '').replace(/\/+$/, ''); };
  var safe = function (u) { return /^(\/(?!\/)|https:\/\/)/i.test(u) ? u : ''; };
  var text = function (html) { return new DOMParser().parseFromString('<p>' + (html || '') + '</p>', 'text/html').body.textContent.replace(/\s+/g, ' ').trim(); };
  var fmt = function (d) { var t = new Date(d); return isNaN(t) ? '' : t.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }); };
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt) e.textContent = txt; return e; }
  function setImg(img, src) {
    var small = src.replace(/(\.[a-z]+)(\?.*)?$/i, '-600x338$1');
    img.src = small;
    img.onerror = function () { img.onerror = null; if (img.src !== src) img.src = src; };
  }
  function getText(url) {
    return fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw r.status; return r.text(); });
  }

  function sitemapImages(url) {
    return (url ? getText(url) : Promise.resolve('')).catch(function () { return ''; }).then(function (xml) {
      var images = {};
      if (!xml) return images;
      var sm = new DOMParser().parseFromString(xml, 'text/xml');
      Array.prototype.forEach.call(sm.getElementsByTagName('url'), function (u) {
        var loc = u.getElementsByTagName('loc')[0], im = u.getElementsByTagName('image:loc')[0];
        if (loc && im) images[slugOf(loc.textContent)] = safe(toBlog(im.textContent));
      });
      return images;
    });
  }

  function renderFeed(root) {
    var list = root.querySelector('.mv2-blog__list');
    var feedUrl = root.getAttribute('data-feed');
    var count = parseInt(root.getAttribute('data-count'), 10) || 3;
    var fail = function () { list.hidden = true; list.removeAttribute('aria-busy'); };
    if (!list || !feedUrl) return list && fail();
    Promise.all([getText(feedUrl), sitemapImages(root.getAttribute('data-sitemap'))]).then(function (res) {
      var xml = new DOMParser().parseFromString(res[0], 'text/xml');
      var images = res[1];
      var posts = Array.prototype.slice.call(xml.getElementsByTagName('item'), 0, count).map(function (it) {
        var g = function (n) { var e = it.getElementsByTagName(n)[0]; return e ? e.textContent : ''; };
        var link = safe(toBlog(g('link')));
        return { link: link, title: text(g('title')), excerpt: text(g('description')).replace(/\s*\[(…|&hellip;|\.\.\.)\]\s*$/, '…'), date: fmt(g('pubDate')), img: images[slugOf(link)] || '' };
      }).filter(function (p) { return p.link && p.title; });
      if (!posts.length) return fail();
      list.textContent = '';
      posts.forEach(function (p) {
        var li = el('li', 'mv2-blog__item');
        var a = el('a', 'mv2-post'); a.href = p.link;
        var media = el('span', 'mv2-post__media');
        if (p.img) { var img = el('img'); img.alt = ''; img.loading = 'lazy'; img.decoding = 'async'; img.width = 600; img.height = 338; setImg(img, p.img); media.appendChild(img); }
        var body = el('div', 'mv2-post__body');
        body.appendChild(el('h3', 'mv2-post__title', p.title));
        if (p.excerpt) body.appendChild(el('span', 'mv2-post__excerpt', p.excerpt));
        if (p.date) body.appendChild(el('span', 'mv2-post__date', p.date));
        a.appendChild(media); a.appendChild(body); li.appendChild(a); list.appendChild(li);
      });
      list.removeAttribute('aria-busy');
    }).catch(fail);
  }

  function whenNear(node, fn) {
    if (!('IntersectionObserver' in window)) return fn();
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); fn(); }
    }, { rootMargin: '600px 0px' });
    io.observe(node);
  }

  function init() {
    document.querySelectorAll('[data-mv2-blog]').forEach(function (root) { whenNear(root, function () { renderFeed(root); }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
